export default "__VITE_ASSET__CNt4Kzm7__"